import React from 'react'

import LayoutAuth from 'components/layouts/LayoutAuth'
import TemplateSignUp from 'components/templates/TemplateSignUp'
import {TPageComponent} from 'src/types'

interface ISignUpProps {}

const SignUp: TPageComponent<ISignUpProps> = () => {
	return <TemplateSignUp />
}

SignUp.displayName = 'SignUp'

SignUp.Layout = LayoutAuth

export default SignUp
